import { ComponentPropsWithRef, forwardRef, ForwardRefRenderFunction, ReactNode } from 'react'
import { LuCheck } from 'react-icons/lu'

import styles from './CheckboxInput.module.css'

export type CheckboxInputProps = (
  | {
      label?: string
      children: ReactNode
    }
  | {
      label: string
      children?: ReactNode
    }
) &
  Omit<ComponentPropsWithRef<'input'>, 'type'> & {
    error?: boolean
  }

export const CheckboxInputRender: ForwardRefRenderFunction<HTMLInputElement, CheckboxInputProps> = (
  {
    label = undefined,
    children = undefined,
    className: _className = '',
    error = false,
    ...inputProps
  }: CheckboxInputProps,
  ref,
) => {
  return (
    <label className={styles.toggleContainer}>
      <input
        type="checkbox"
        ref={ref}
        style={{ display: 'none' }}
        {...inputProps}
        className={[styles.toggleInput, 'className' in inputProps ? inputProps.className : ''].join(
          ' ',
        )}
      />
      <span className={[styles.toggleBlock, error ? styles.error : ''].join(' ')}>
        <LuCheck className={styles.toggleChip} size={24} strokeWidth={1.5} />
      </span>
      {children ?? label}
    </label>
  )
}
export const CheckboxInput = forwardRef(CheckboxInputRender)
